import { type ITopOfferBuyersQuery } from 'application/querySchemas/ITopOfferBuyersQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type ITopOfferBuyersClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/ITopOfferBuyersClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class TopOfferBuyersQuery implements ITopOfferBuyersQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('ITopOfferBuyersClient')
        public readonly topOfferBuyersClient: ITopOfferBuyersClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.topOfferBuyersClient.get({
            token: this.buyerUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
